<template>
    <div class="nav">
        <router-link :to="{ name: 'dashboard' }" class="nav__brand">
            <app-logo />
        </router-link>

        <div class="nav__group">
            <span class="nav__group__ttl">General</span>

            <ul class="nav__links">
                <router-link tag="li" :to="{ name: 'dashboard' }" class="nav__item">
                    <a class="nav__item__link">
                        <app-icon icon="tachometer-alt" />
                        <span>Dashboard</span>
                    </a>
                </router-link>

                <span @click="toggleMedia()" class="nav__item">
                    <a class="nav__item__link">
                        <app-icon icon="images" />
                        <span>Media</span>
                    </a>
                </span>

                <router-link tag="li" :to="{ name: 'careers.home' }" class="nav__item" v-if="checkPermission('careers', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="briefcase" />
                        <span>Careers</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'forms.home' }" class="nav__item" v-if="checkPermission('forms', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="file" />
                        <span>Forms</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'menus.home' }" class="nav__item" v-if="checkPermission('menus', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="bars" />
                        <span>Menus</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'locations.home' }" class="nav__item" v-if="checkPermission('locations', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="map-marker-alt" />
                        <span>Locations</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'articles.home' }" class="nav__item" v-if="checkPermission('articles', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="newspaper" />
                        <span>Articles</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'offers.home' }" class="nav__item">
                    <a class="nav__item__link">
                        <app-icon icon="tags" />
                        <span>Offers</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'pages.home' }" class="nav__item"  v-if="checkPermission('pages', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="sitemap" />
                        <span>Pages</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'services.home' }" class="nav__item" v-if="checkPermission('services', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="box-open" />
                        <span>Services</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'tyres.home' }" class="nav__item" v-if="checkPermission('tyres', 'edit')">
                    <a class="nav__item__link">
                        <app-icon icon="cog" />
                        <span>Tyres</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'quicklinks.home' }" class="nav__item" v-if="checkPermission('quicklinks', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="link" />
                        <span>Quick Links</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'referrals.home' }" class="nav__item" v-if="checkPermission('quicklinks', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="user-friends" />
                        <span>Referrals</span>
                    </a>
                </router-link>
            </ul>
        </div>

        <div class="nav__group">
            <span class="nav__group__ttl">Management</span>

            <ul class="nav__links">
                <router-link tag="li" :to="{ name: 'translations.home' }" class="nav__item" v-if="checkPermission('translations', 'edit')">
                    <a class="nav__item__link">
                        <app-icon icon="language" />
                        <span>Translations</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'groups.home' }" class="nav__item" v-if="checkPermission('groups', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="user-tag" />
                        <span>Groups</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'users.home' }" class="nav__item" v-if="checkPermission('users', 'view')">
                    <a class="nav__item__link">
                        <app-icon icon="users" />
                        <span>Users</span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{ name: 'settings.home' }" class="nav__item" v-if="checkPermission('settings', 'edit')">
                    <a class="nav__item__link">
                        <app-icon icon="cog" />
                        <span>Settings</span>
                    </a>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
    /* Components */
    import Logo from '@/components/Logo';

    import permissions from '@/mixins/permissions';

    export default {
        name: 'app-navigation',

        components: {
            'app-logo': Logo
        },

        mixins: [
            permissions
        ],

        methods: {
            toggleMedia() {
                this.$emit('toggle-media', true);
            }
        }
    }
</script>

<style lang="scss">
    .nav {
        @apply .fixed .pin-t .pin-b .pin-l .z-10 .block .bg-blue .text-white;

        overflow-y: scroll;

        width: 250px;

        &__brand {
            @apply .block;

            padding: 0.35rem 2rem 2rem 2rem;

            svg {
                @apply .block .max-w-full .h-auto;

                path {
                    fill: white;
                }
            }
        }

        &__group {
            @apply .block .mb-6;

            &__ttl {
                @apply .block .px-4 .mb-2 .uppercase .text-white .text-xs;
            }
        }

        &__links {
            @apply .list-reset;
        }

        &__item {
            @apply .block;

            &__link {
                @apply .relative .block .py-4 .px-6 .bg-transparent .opacity-75 .text-white .text-base .no-underline .font-light;

                transition: opacity 0.2s ease-in-out;

                svg {
                    width: 18px !important;
                    height: 18px !important;

                    @apply .mr-1 .text-center;
                }

                &:hover,
                &:focus {
                    @apply .no-underline .opacity-100;
                }

                .router-link-active & {
                    @apply .bg-blue-darker .opacity-100 .text-white;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/template/Navigation.vue